<template>
  <header :class="{editing}">
    <h3>{{label}}
      <span @click="$emit('edit')" v-if="editable && !editing">
        <button class="button is-small is-white">
          <i class="fal fa-pencil-alt has-text-primary" aria-hidden="true"></i>&nbsp;<span class="editText has-text-primary">{{$t('edit')}}</span>
        </button>
      </span>
      <span v-if="editing">
        <button class="button is-small is-primary" @click="$emit('save')">{{$t('save')}}</button>
        <button class="button is-small is-danger" @click="$emit('cancel')">{{$t('cancel')}}</button>
      </span>
      <div class="help has-text-danger" v-if="editing && message">
        <span>{{message}}</span>
      </div>
    </h3>
  </header>
</template>

<script>
import componentState from '@/mixins/component-state'
import state from '../../state'

export default {
  mixins: [componentState],
  props: ['label', 'editing', 'message'],
  computed: {
    editable: function () {
      return this._get(state.editable.profile, false)
    }
  }
}
</script>

<style lang="scss" scoped>
  h3 {
    font-weight: 600;
  }

  header {
    &.editing {
      margin-bottom: 0.5rem;
    }
  }
</style>
